import axios from "axios";
import config from "../Config.json";

const GenerateOtp = async (data) => {
    try {       
        const response = await axios.post(`${config.API_URL}/app/generateOTP`, data)
        return response
    } catch (error) {
        return error
    }
}

export default GenerateOtp;